

















































type Prop<T> = () => T;
import Vue from "vue";
export default Vue.extend({
  props: {
    label: String,
    items: {
      type: Array,
      default: [] as any[],
    },
    syllableIndex: Number,
    // 実際の値に使う階層 (1 なら 1階層目の値, 2 なら 2階層目の配列の値が使われる)
    valueNodeLevel: {
      type: Number,
      default: 2,
    },
    value: { type: Array },
  },
  data() {
    return {
      // ツリービューの v-model バインド用
      selections: [],
      // ノード番号: { text, order, value } 
      nodes: {},
    };
  },
  computed: {
    tree(): any[] {
      if (!this.items) return [];
      let n = 0;
      const nodes = {} as any;
      const tree = (this.items as string[])
        .filter((g: any) => {
          if (!g.targetSyllables || g.targetSyllables === "0") return true;
          return (
            g.targetSyllables
              .split(",")
              .indexOf(this.syllableIndex.toString()) !== -1
          );
        })
        .map((g: any) => {
          n++;
          const node = {
            id: g.value || n,
            name: g.displayText || g.group,
          };
          if (this.valueNodeLevel === 1 || !g.values) {
            nodes[node.id] = { text: node.name, order: n, value: g.value || g.group };
          }
          if (g.values) {
            Object.assign(node, {
              children: g.values.map((v: any) => {
                n++;
                if (this.valueNodeLevel === 2) {
                  nodes[n] = { text: v, order: n, value: v };
                }
                return { id: n, name: v };
              }),
            });
          }
          return node;
        });
      this.nodes = nodes;
      return tree;
    },
    // selections をソートしたもの
    sortedSelections(): number[] {
      if (!this.selections || !this.items) return [];
      const selections = [...(this.selections as number[])]; // sort は破壊的なので一旦コピー
      const nodes: any = this.nodes;
      return selections
        .filter(x => Object.keys(nodes).indexOf(x.toString()) !== -1)
        .sort((a, b) => nodes[a].order - nodes[b].order);
    },

    selectedTexts(): string[] {
      const nodes: any = this.nodes;
      const selectedTexts = (this.sortedSelections as number[])
        .map(id => nodes[id] && nodes[id].text).filter(x => !!x);
      return selectedTexts;
    },
    selectedValues(): string[] {
      const nodes: any = this.nodes;
      const selectedValues = (this.sortedSelections as number[])
        .map(id => nodes[id] && nodes[id].value).filter(x => !!x);
      return selectedValues;
    },
  },
  watch: {
    // ツリービューの選択が変更されたとき
    selections() {
      // input イベントを発火
      (this as any).$emit('input', this.selectedValues);
    },
    // コンポーネント外から値が設定されるとき
    value(values) {
      values = values || [];
      // すべて一致する場合は抜ける
      if ((this.selectedValues as any).every((x: any) => values.indexOf(x) >= 0))
        return;
      const nodes: any = this.nodes;
      // ノードの値からキー (ノード番号) を返す
      function getKeyByValue(val: any) {
        return Object.keys(nodes).find(key => nodes[key].value === val);
      }
      // 選択済みの項目を選択しなおす
      this.selections = values.map((x: any) => getKeyByValue(x));
    },
  },
});
